import { render, staticRenderFns } from "./EmbryonManagement.vue?vue&type=template&id=ef12c57c&"
import script from "./EmbryonManagement.vue?vue&type=script&lang=js&"
export * from "./EmbryonManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports